import Resource from "./Resource";
export default Resource;


// WEBPACK FOOTER //
// ./src/Resource/index.js